import { render, staticRenderFns } from "./VoteOptions.vue?vue&type=template&id=a6a0cf18&scoped=true&lang=pug&"
import script from "./VoteOptions.vue?vue&type=script&lang=js&"
export * from "./VoteOptions.vue?vue&type=script&lang=js&"
import style0 from "./VoteOptions.vue?vue&type=style&index=0&id=a6a0cf18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a0cf18",
  null
  
)

export default component.exports